
export const Mixin = {
	watch:{
		checked(val){
				this.isChecked = val
			},
			isChecked(val){
				if(!val){
					this.$store.dispatch('removeCheckedVehicle',this.data.id)
				}else{
					this.$store.dispatch('getCheckedVehicle',this.data.id)
				}
			}
	},
	methods: {
			clickLock(flag,id){	// 点击锁定、解锁
				if(flag===1){
					this.data.lockFlg = 0
				}else{
					this.data.lockFlg = 1
				}
				const obj = {
					isLocked:this.data.lockFlg,
					listId:id
				}
				// TODO 同步后台
				this.$store.dispatch('updateLockFlag',obj)
			}
  		}
	}






// WEBPACK FOOTER //
// ./src/components/pages/didivehicletrace/list/mixin.js